export default __webpack_public_path__ + "static/media/arrow.2be9afbd.svg";